import { BaseQueryApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/dist/query';
import config from '../../config/config';
import { logout } from '../slices/auth';
import { readScannerSession } from '../../utils/scannerStorage';

interface State {
  auth: { token: string | null }
}

// The v2 scanner talks with an account (Bearer) or with a session opened by
// link or code (X-Scanner-Session). It does not toast: every error has its
// own screen in the scanner, and a toast over the result hides the name.
const baseQuery = fetchBaseQuery({
  baseUrl: `${config.baseURL}/v1/`,
  prepareHeaders: (headers, { getState }) => {
    const session = readScannerSession();
    if (session?.mode === 'code') {
      headers.set('x-scanner-session', session.token);
      return headers;
    }
    const { token } = (getState() as State).auth;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
  timeout: 10_000,
});

const scannerBaseQuery = async (args: string | FetchArgs, api: BaseQueryApi, extraOptions: object) => {
  const result = await baseQuery(args, api, extraOptions);
  // A code session that ended is "Tu acceso terminó", not a logout: the
  // scanner reads the error. An account whose token died logs out as anywhere.
  if (result.meta?.response?.status === 401 && readScannerSession()?.mode !== 'code') {
    api.dispatch(logout());
  }
  return result;
};

export default scannerBaseQuery;
